import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = ["title"]
const _hoisted_3 = ["tab-title"]
const _hoisted_4 = ["tab-title"]
const _hoisted_5 = ["tab-title"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_7 = { class: "validate-buttons center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "center padding"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("dig-ui-loader", null, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["pageCount", "currentPage", "previous-text", "next-text"]
const _hoisted_13 = ["pageCount", "currentPage", "previous-text", "next-text"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search_demand_form = _resolveComponent("search-demand-form")!
  const _component_filter_demand_form = _resolveComponent("filter-demand-form")!
  const _component_demand_form = _resolveComponent("demand-form")!
  const _component_card_demand = _resolveComponent("card-demand")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, {
    marginBottom: "",
    class: "view-requests"
  }, {
    default: _withCtx(() => [
      _createElementVNode("dig-ui-title", null, [
        _createTextVNode(_toDisplayString(_ctx.$t('listOfDemands', { project: _ctx.project.name })) + " " + _toDisplayString(_ctx.demands.length) + " / " + _toDisplayString(_ctx.allDemands.length) + " ", 1),
        _createElementVNode("dig-ui-icon", {
          type: "show",
          class: "icon-button background",
          title: _ctx.$t('show'),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAllDetail()))
        }, null, 8, _hoisted_1),
        _createElementVNode("dig-ui-icon", {
          type: "hide",
          class: "icon-button background",
          title: _ctx.$t('hide'),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideAllDetail()))
        }, null, 8, _hoisted_2)
      ]),
      _createElementVNode("dig-ui-tabset", {
        onSelect: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changeTab($event)))
      }, [
        _createElementVNode("dig-ui-tab", {
          "tab-title": _ctx.$t('search'),
          selected: true
        }, [
          _createVNode(_component_search_demand_form, {
            class: "padding-side-10",
            demand: _ctx.searchForm,
            onUpdate: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateSearch($event))),
            onSearch: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validateSearch())),
            onReset: _cache[4] || (_cache[4] = ($event: any) => (_ctx.resetSearch()))
          }, null, 8, ["demand"])
        ], 8, _hoisted_3),
        _createElementVNode("dig-ui-tab", {
          "tab-title": _ctx.$t('sort')
        }, [
          _createVNode(_component_filter_demand_form, {
            filters: _ctx.filters,
            onUpdate: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateFilter($event)))
          }, null, 8, ["filters"])
        ], 8, _hoisted_4),
        _createElementVNode("dig-ui-tab", {
          "tab-title": _ctx.$t('Demand.new')
        }, [
          _createVNode(_component_demand_form, {
            class: "demand-form padding-side-10",
            demand: _ctx.demandToCreate,
            project: _ctx.project,
            isAdmin: _ctx.isAdmin,
            createForm: true,
            onUpdate: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateCreateDemande($event)))
          }, null, 8, ["demand", "project", "isAdmin"]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("dig-ui-standard-button", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.reinitCreateForm())),
              class: "cancel"
            }, _toDisplayString(_ctx.$t('reinit')), 1),
            _createElementVNode("dig-ui-standard-button", {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.createDemand()))
            }, _toDisplayString(_ctx.$t('create')), 1)
          ])
        ], 8, _hoisted_5)
      ], 32),
      _hoisted_8,
      _createElementVNode("div", null, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
          : _createCommentVNode("", true),
        (_ctx.demands.length > _ctx.elementsPerPage)
          ? (_openBlock(), _createElementBlock("dig-ui-pagination", {
              key: 1,
              class: "padding-b-20",
              pageCount: Math.ceil(_ctx.demands.length / _ctx.elementsPerPage),
              onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.currentPage = $event.detail)),
              currentPage: _ctx.currentPage,
              "previous-text": _ctx.$t('previousShort'),
              "next-text": _ctx.$t('nextShort')
            }, null, 40, _hoisted_12))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.demands.filter(
          (s, index) =>
            index >= (_ctx.currentPage - 1) * _ctx.elementsPerPage &&
            index < _ctx.currentPage * _ctx.elementsPerPage,
        ), (demand, i) => {
          return (_openBlock(), _createBlock(_component_card_demand, {
            key: demand.id,
            demand: demand,
            project: _ctx.project,
            isAdmin: _ctx.isAdmin,
            onUpdateField: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateDemandField($event))),
            onUpdate: _cache[12] || (_cache[12] = ($event: any) => (_ctx.refreshDemands($event))),
            ref: 
          (el) => {
            if (el) _ctx.cardDemands[i] = el
          }
        
          }, null, 8, ["demand", "project", "isAdmin"]))
        }), 128)),
        (_ctx.demands.length > _ctx.elementsPerPage)
          ? (_openBlock(), _createElementBlock("dig-ui-pagination", {
              key: 2,
              class: "padding-t-20",
              pageCount: Math.ceil(_ctx.demands.length / _ctx.elementsPerPage),
              onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.currentPage = $event.detail)),
              currentPage: _ctx.currentPage,
              "previous-text": _ctx.$t('previousShort'),
              "next-text": _ctx.$t('nextShort')
            }, null, 40, _hoisted_13))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}